/**
 * @generated SignedSource<<1496f0e8ff739655e0f6aac96502232d>>
 * @relayHash fab2939fd952dc2aefe9fe471ff8ac52
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fab2939fd952dc2aefe9fe471ff8ac52

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddToListMenu_Query$variables = {
  userProfileId: string;
};
export type AddToListMenu_Query$data = {
  readonly visitor: {
    readonly userAccount: {
      readonly " $fragmentSpreads": FragmentRefs<"AddToListMenu_userAccount">;
    } | null;
  };
};
export type AddToListMenu_Query = {
  response: AddToListMenu_Query$data;
  variables: AddToListMenu_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userProfileId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userProfileId",
    "variableName": "userProfileId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddToListMenu_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "args": (v1/*: any*/),
                "kind": "FragmentSpread",
                "name": "AddToListMenu_userAccount"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddToListMenu_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "workspaceForSelectedUserType",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                              "groupNid": "NETWORK_LIST"
                            }
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 200
                          }
                        ],
                        "concreteType": "UserListConnection",
                        "kind": "LinkedField",
                        "name": "userLists",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserListUserProfileEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserList",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExpertProgram",
                                    "kind": "LinkedField",
                                    "name": "expertProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "expertPartnership",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": (v1/*: any*/),
                                    "kind": "ScalarField",
                                    "name": "isUserProfileInList",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "userLists(filter:{\"groupNid\":\"NETWORK_LIST\"},first:200)"
                      }
                    ],
                    "type": "ClientWorkspace",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fab2939fd952dc2aefe9fe471ff8ac52",
    "metadata": {},
    "name": "AddToListMenu_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b67315c6e4cca09c75ce7ad2f2f59d38";

export default node;
